import { TermsOfUsePage } from "@/features/legal/terms-of-use.page";
import { createFileRoute } from "@tanstack/react-router";

// Public on purpose (outside `_authenticated`): the log-in / sign-up consent
// line and the AppFooter link here, and both are shown signed out (CR-275).
export const Route = createFileRoute("/terms")({
  component: TermsOfUsePage,
});
